/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConfirmedActionItemDto } from "./ConfirmedActionItemDto";
import {
  ConfirmedActionItemDtoFromJSON,
  ConfirmedActionItemDtoFromJSONTyped,
  ConfirmedActionItemDtoToJSON,
  ConfirmedActionItemDtoToJSONTyped,
} from "./ConfirmedActionItemDto";

/**
 *
 * @export
 * @interface LogCarrierMeetingRequest
 */
export interface LogCarrierMeetingRequest {
  /**
   *
   * @type {string}
   * @memberof LogCarrierMeetingRequest
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof LogCarrierMeetingRequest
   */
  jamieMeetingId: string;
  /**
   *
   * @type {Array<ConfirmedActionItemDto>}
   * @memberof LogCarrierMeetingRequest
   */
  actionItems: Array<ConfirmedActionItemDto>;
  /**
   *
   * @type {string}
   * @memberof LogCarrierMeetingRequest
   */
  notes?: string | null;
}

/**
 * Check if a given object implements the LogCarrierMeetingRequest interface.
 */
export function instanceOfLogCarrierMeetingRequest(
  value: object,
): value is LogCarrierMeetingRequest {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("actionItems" in value) || value["actionItems"] === undefined)
    return false;
  return true;
}

export function LogCarrierMeetingRequestFromJSON(
  json: any,
): LogCarrierMeetingRequest {
  return LogCarrierMeetingRequestFromJSONTyped(json, false);
}

export function LogCarrierMeetingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogCarrierMeetingRequest {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    jamieMeetingId: json["jamieMeetingId"],
    actionItems: (json["actionItems"] as Array<any>).map(
      ConfirmedActionItemDtoFromJSON,
    ),
    notes: json["notes"] == null ? undefined : json["notes"],
  };
}

export function LogCarrierMeetingRequestToJSON(
  json: any,
): LogCarrierMeetingRequest {
  return LogCarrierMeetingRequestToJSONTyped(json, false);
}

export function LogCarrierMeetingRequestToJSONTyped(
  value?: LogCarrierMeetingRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    jamieMeetingId: value["jamieMeetingId"],
    actionItems: (value["actionItems"] as Array<any>).map(
      ConfirmedActionItemDtoToJSON,
    ),
    notes: value["notes"],
  };
}
